export default __webpack_public_path__ + "static/media/Automated_Payments.aacde650.svg";